import React from 'react';
import { getDirectusImg } from 'services/graphql/directus';
import { BlogType } from 'types';

import { DLink } from '@dnse/ui';

import { CustomImage } from '../CustomImage';

interface Props {
  blog: BlogType;
}

export const BlogCard: React.FC<Props> = ({ blog }) => {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const { title, cover_image, slug } = blog;
  return (
    <DLink href={`blog/${slug}`}>
      <div className="flex flex-col gap-y-0.5 w-full">
        <CustomImage
          src={getDirectusImg(cover_image)}
          alt={title}
          height={200}
          className="rounded"
        />
        <h4 className={`text-lg font-semibold mt-2 line-clamp-3 `}>{title}</h4>
      </div>
    </DLink>
  );
};
